// extracted by mini-css-extract-plugin
module.exports = {"container":"SubHeading1_container__1bXQY","heading":"SubHeading1_heading__2ls21","sending":"SubHeading1_sending__1RDDh"};